/**
 * Chrome-free routes — public / marketing / auth surfaces that must not
 * mount the authenticated AppShell (sidebar, navbar, footer, ProtectedRoute).
 *
 * Shared by ConditionalLayout (shell switch) and AppShellLayout (defense-in-depth).
 * Desk routes (dashboard, trading, portfolio, agents, settings, …) are not listed
 * and always use the app shell.
 */

export function isChromeFreeRoute(pathname: string | null | undefined): boolean {
  if (!pathname) return true

  // Landing
  if (pathname === '/') return true

  // Auth (client + employee)
  if (pathname.startsWith('/auth')) return true
  if (pathname === '/login' || pathname === '/signin') return true

  // Public legal docs (reachable from login / footer without app shell)
  if (pathname.startsWith('/legal')) return true
  if (pathname === '/privacy' || pathname === '/terms') return true

  // Public marketing surfaces
  if (pathname === '/pricing' || pathname.startsWith('/pricing/')) return true
  if (pathname === '/help' || pathname.startsWith('/help/')) return true
  if (pathname === '/journal' || pathname.startsWith('/journal/')) return true
  if (pathname === '/trading/preview' || pathname.startsWith('/trading/preview/')) {
    return true
  }

  // Legacy public register path (pre-auth)
  if (pathname === '/register') return true

  return false
}
